var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgThumbUp = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 42H14V16L28 2L30.5 4.5C30.7333 4.73333 30.925 5.05 31.075 5.45C31.225 5.85 31.3 6.23333 31.3 6.6V7.3L29.1 16H42C43.0667 16 44 16.4 44.8 17.2C45.6 18 46 18.9333 46 20V24C46 24.2333 45.9667 24.4833 45.9 24.75C45.8333 25.0167 45.7667 25.2667 45.7 25.5L39.7 39.6C39.4 40.2667 38.9 40.8333 38.2 41.3C37.5 41.7667 36.7667 42 36 42ZM18 38H36L42 24V20H24L26.7 9L18 17.7V38ZM14 16V20H8V38H14V42H4V16H14Z",
    fill: "#008908"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThumbUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thumb_up.99c62c5c.svg";
export { ForwardRef as ReactComponent };